import { Button, Grid, Paper } from '@mui/material';
import { withStyles } from 'utils/styles';
import InputAdornment from '@mui/material/InputAdornment';
import Fingerprint from '@mui/icons-material/Fingerprint';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Alert from 'components/Alert';
import { cleanAlert } from 'ducks/alerts';
import { login } from 'ducks/auth';
//import reachOKLogo from 'images/brand/REACHok_branco.png';
import reachOKLogo from 'images/brand/LOGO_FINAL_REACHOK_Prancheta 1.png';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { connect } from 'react-redux';
import history from 'source/history';
import styles from './styles';
import theme from 'source/theme';

const Component = props => {
  const { classes, alert } = props;
  const { cleanAlert } = props;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleChangeEmail = event => {
    setEmail(event.target.value);
  };

  const handleChangePassword = event => {
    setPassword(event.target.value);
  };

  const handleSubmit = () => {
    props.login(email, password);
  };

  return (
    <div className={classes.container}>
      <div className={classes.loginArea}>
        <Paper className={classes.paper}>
          <div className={classes.margin}>
            <Alert
              open={alert.message.length !== 0}
              message={alert.message}
              handleClose={cleanAlert}
              placement={{ vertical: 'bottom', horizontal: 'left' }}
              variant={'error'}
            />

            <Grid sx={{ justifyContent: 'center' }} container>
              <Grid size={4}>
                <img src={reachOKLogo} style={{ width: '100%' }} alt=""/>
              </Grid>
            </Grid>

            <ValidatorForm onSubmit={handleSubmit}>
              <Grid container className={classes.textInput}>
                <Grid size="grow">
                  <TextValidator
                    // `variant` explicitly, because the theme's default
                    // does not reach here: the validator does
                    // `require('@mui/material/TextField')` - CommonJS - while
                    // the application imports the ESM build, and rspack bundles
                    // both. Each copy has its own defaults context, so the
                    // ThemeProvider fills one and this TextField reads the
                    // other, empty, and falls back to v5's `outlined`. v4's
                    // default was `standard`, an underline, which is what the
                    // login screen has always looked like.
                    variant="standard"
                    slotProps={{ input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountCircle className={classes.iconColor} style={{ fontSize: 30 }}/>
                        </InputAdornment>
                      )
                    } }}
                    label="Utilizador"
                    onChange={handleChangeEmail}
                    name="email"
                    value={email}
                    // validators={['required', 'isEmail']}
                    validators={['required']}
                    errorMessages={['this field is required', 'email is not valid']}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid container className={classes.textInput}>
                <Grid size="grow">
                  <TextValidator
                    variant="standard"
                    slotProps={{ input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <Fingerprint className={classes.iconColor} style={{ fontSize: 30 }}/>
                        </InputAdornment>
                      )
                    } }}
                    label="Password"
                    onChange={handleChangePassword}
                    name="password"
                    value={password}
                    validators={['required']}
                    errorMessages={['this field is required']}
                    fullWidth
                    type='password'
                  />
                </Grid>
              </Grid>

              <Grid sx={{ justifyContent: 'flex-end' }} container style={{ marginTop: '30px' }}>
                <div
                  onClick={() => history.push('/forgot_password')}
                  style={{
                    cursor: 'pointer',
                    color: theme.palette.secondary.dark
                  }}
                >
                  Forgot password?
                </div>
              </Grid>

              <Grid sx={{ justifyContent: 'center' }} container style={{ marginTop: '30px' }}>
                <Button
                  type="submit"
                  className={classes.textTransformationNone}
                  variant="contained"
                  color="secondary"
                >
                  Login
                </Button>
              </Grid>
            </ValidatorForm>
          </div>
        </Paper>
      </div>
    </div>
  );
};

Component.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  alert: state.alert
});

const mapDispatchToProps = dispatch => ({
  login(user, password) {
    dispatch(login(user, password));
  },
  cleanAlert() {
    dispatch(cleanAlert());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Component));
